import { message, Popconfirm, Tooltip } from 'antd';
import moment from 'moment';
import React, { memo, useCallback } from 'react';
import { attachmentsActions } from '../../../actions/attachments.actions';
import getAttachmentType from '../../../helpers/getAttachmentType';
import { CrossCircleIcon, FileIcon } from '../../../resource/icons';
import parentTypes from '../constants/parentTypes';
import PDFPreviewIcon from '../PDFPreviewIcon/PDFAttachmentPreviewIcon';
import PicturePreviewIcon from '../PicturePreviewIcon/PicturePreviewIcon';
import styles from './Attachment.module.scss';
import { emit } from '../../../helpers/events';

const Attachment = ({
  textStyles,
  attachment,
  allowedDelete,
  getAttachmentsList,
  allAttachments,
  parentId,
  parentType,
  hideMetaData,
  customDeleteAttachment,
  customDownloadAttachment,
  getPreviewAttachment,
}) => {
  const attachmentType = getAttachmentType(attachment.name);
  const deleteAttachment = useCallback(async () => {
    try {
      if (customDeleteAttachment) {
        customDeleteAttachment(attachment.id, parentId);
      } else {
        if (attachment.isCommentAttach) {
          await attachmentsActions.deleteAttachment(
            parentId,
            attachment.id,
            parentTypes.docsComment
          );
          emit('chatAttachmentDeleted', { parentId });
        } else {
          await attachmentsActions.deleteAttachment(
            parentId,
            attachment.id,
            parentType
          );
        }
      }
      getAttachmentsList('update');
    } catch (error) {
      console.error(error);
      message.error('Не удалось удалить вложение');
    }
  }, [
    parentId,
    attachment.id,
    parentType,
    getAttachmentsList,
    customDeleteAttachment,
  ]);

  const downloadAttachment = () => {
    try {
      if (customDownloadAttachment) {
        customDownloadAttachment(
          attachment.fileName,
          parentId,
          attachment.name
        );
      } else {
        attachmentsActions.fetchAttachment(
          parentId,
          attachment.fileName,
          attachment.name,
          parentType
        );
      }
    } catch (error) {
      message.error('Не удалось скачать файл');
      console.error(error);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.mainRow}>
        <div className={styles.leftSide}>
          <div className={styles.mainInfo}>
            {attachmentType === 'picture' && (
              <PicturePreviewIcon
                getPreviewAttachment={getPreviewAttachment}
                allAttachments={allAttachments}
                parentId={parentId}
                attachment={attachment}
                parentType={parentType}
              />
            )}
            {attachmentType === 'file-pdf' && (
              <PDFPreviewIcon
                parentId={parentId}
                attachment={attachment}
                parentType={parentType}
              />
            )}
            {attachmentType !== 'picture' && attachmentType !== 'file-pdf' && (
              <FileIcon />
            )}
            <Tooltip title={`Скачать "${attachment.name}"`}>
              <div
                style={textStyles}
                className={styles.fileName}
                onClick={downloadAttachment}
              >
                {attachment.name}
              </div>
            </Tooltip>
          </div>

          {!hideMetaData && (
            <div style={textStyles} className={styles.metaData}>
              {attachment.user?.specialityName && (
                <span className={styles.speciality}>
                  {attachment.user?.specialityName}{' '}
                </span>
              )}
              {attachment.user?.fullName}{' '}
              {attachment.createDate &&
                moment(attachment.createDate).format('DD.MM.YY в HH:mm')}
            </div>
          )}
        </div>
        {allowedDelete && (
          <Popconfirm
            onConfirm={deleteAttachment}
            title="Удалить вложение?"
            okText="Да"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={styles.crossIcon}
            >
              <path
                d="M14.83 9.17L9.17004 14.83"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.83 14.83L9.17004 9.17"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Popconfirm>
        )}
      </div>
    </div>
  );
};

export default memo(Attachment);
